// extracted by mini-css-extract-plugin
export default {"wrapper":"TodoList_wrapper__jljEg"};